import { Link, useLocation } from "react-router-dom";
import { Bell, Settings, LogOut, User } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { NotificationsModal } from "../common/notifications-modal";
// import { SidebarTrigger } from "../ui/sidebar";

export function Header() {
  const [showNotifications, setShowNotifications] = useState(false);

  const location = useLocation();

  const handleLogout = async () => {
    try {
      await fetch(`${import.meta.env.VITE_API_URL}/auth/logout`, {
        method: "POST",
      });
    } catch (error) {
      console.error("Error during logout:", error);
    }
    window.location.href = "https://app.sandbox.ginja.ai/login";
  };

  return (
    <div className="flex items-center gap-4 mb-2">
      {/* <SidebarTrigger /> */}
      <div className="flex justify-between items-center w-full">
        <div></div>

        {location.pathname === "/" && (
          <div className="flex items-center gap-3 pr-6">
            <Button
              variant="outline"
              size="icon"
              onClick={() => setShowNotifications(true)}
            >
              <Bell className="h-5 w-5" />
            </Button>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon">
                  <User className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-56" align="end" forceMount>
                <DropdownMenuGroup>
                  <DropdownMenuItem asChild>
                    <Link to="/settings">
                      <Settings className="mr-2 h-4 w-4" />
                      <span>Settings</span>
                    </Link>
                  </DropdownMenuItem>
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout}>
                  <LogOut className="mr-2 h-4 w-4" />
                  <span>Log out</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}

        <NotificationsModal
          open={showNotifications}
          onOpenChange={setShowNotifications}
        />
      </div>
    </div>
  );
}
